module.exports = __webpack_public_path__ + "assets/icons-vehicles-24-px.a7393d39.svg";